import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import GradientStrip from "@/components/GradientStrip";
import { api } from "@/lib/config";
import { useT } from "@/lib/i18n";
import { Download } from "lucide-react";

export default function Resources() {
  const t = useT();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/resources").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  return (
    <Layout headerVariant="dark">
      <section data-testid="resources-hero" className="bg-brand-deep text-white pt-40 md:pt-48 pb-20">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
          <p className="section-num text-white/85 fade-up">{t("resources.eyebrow")}</p>
          <h1 className="display text-5xl md:text-7xl lg:text-8xl leading-[0.95] mt-8 max-w-5xl fade-up-2">
            {t("resources.title")}
          </h1>
          <p className="text-white/80 text-lg md:text-xl leading-relaxed mt-8 max-w-3xl fade-up-3">
            {t("resources.lede")}
          </p>
        </div>
        <GradientStrip />
      </section>

      <section className="bg-paper py-20 md:py-28">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
          {items.length === 0 && <p className="text-ink/60">{t("resources.empty")}</p>}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-ink/10">
            {items.map(r => (
              <div key={r.id} className="bg-paper p-10 md:p-12 flex flex-col" data-testid={`resource-${r.id}`}>
                <p className="section-num">{r.category}</p>
                <h3 className="display text-2xl md:text-3xl mt-4 leading-tight">{r.title}</h3>
                <p className="text-[15px] leading-relaxed text-ink/75 mt-4 flex-1">{r.description}</p>
                <a
                  href={r.file_url}
                  download
                  target="_blank" rel="noreferrer"
                  className="btn-pill btn-ghost mt-8 self-start inline-flex"
                  data-testid={`download-${r.id}`}
                >
                  <Download size={16}/> {t("resources.download")}
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
